import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-erase-icon]',
  template: `
    <svg:path
      d="M7.875 12.4688L4.20312 9L2.57812 10.625L2.5625 10.6406V10.6719V10.7031L2.57812 10.7344L4.625 12.7812H7.57812L7.875 12.4688ZM13.1875 6.95312L9.71875 3.48438L5.125 8.0625L8.78125 11.5312L13.1875 6.95312ZM9.25 2.09375L9.34375 2L9.46875 1.95312L9.57812 1.92188L9.71875 1.90625L9.84375 1.92188L9.96875 1.95312L10.0781 2L10.1719 2.09375L14.5625 6.48438L14.6406 6.57812L14.7031 6.70312L14.75 6.8125V6.9375V7.0625L14.7188 7.1875L14.6562 7.29688L14.5781 7.40625L9.39062 12.7812H13.125L13.25 12.8125L13.3125 12.8281L13.4219 12.8906L13.5156 12.9688L13.5938 13.0781L13.6562 13.1875L13.6875 13.3125L13.7031 13.4375L13.6875 13.5781L13.6562 13.6875L13.5938 13.8125L13.5156 13.9062L13.4219 13.9844L13.3125 14.0469L13.1875 14.0781L13.0469 14.0938H4.29688L4.17188 14.0625L4.10938 14.0469L3.98438 13.9844L3.89062 13.9062L1.65625 11.6562L1.5625 11.5625L1.46875 11.4375L1.40625 11.3281L1.34375 11.2031L1.29688 11.0781L1.26562 10.9375L1.25 10.8125V10.6719V10.5469L1.26562 10.4062L1.29688 10.2812L1.34375 10.1562L1.40625 10.0312L1.46875 9.90625L1.5625 9.79688L1.65625 9.6875L9.25 2.09375Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EraseIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
